// styles
import { labelStyles, themeOptions } from 'styles';

// libraries
import styled, { css } from 'styled-components';

interface StyledBasicAutocompleteV2Props {
  $labelPosition?: 'top' | 'left';
}

export const StyledBasicAutocompleteV2 = styled.div<StyledBasicAutocompleteV2Props>`
  position: relative;
  height: auto;
  margin-bottom: 0;

  ${({ $labelPosition }) =>
    $labelPosition === 'left' &&
    css`
      ${labelStyles}
    `}

  span {
    font-weight: 600;
  }

  > span {
    display: inline-block;
    margin-bottom: 7px;
  }

  .ba-label {
    display: flex;
    align-items: center;
    position: relative;
    padding-left: 8px;

    span {
      width: 10px;
      height: 5px;
      position: relative;
      top: -4px;
      left: 2px;
    }
  }

  .MuiAutocomplete-inputRoot {
    padding: 0 53px 0 0;
    width: 100%;
    background-color: ${themeOptions.palette.white.main};

    button {
      color: ${themeOptions.palette.gray.dark} !important;
    }
  }

  .MuiOutlinedInput-root {
    padding-right: 0px;
    width: 100%;
    border: 1px solid ${themeOptions.palette.gray.border};
    border-radius: 6px;

    &:hover {
      box-shadow: 0px 0px 0px 3px var(--color-off-white);

      .MuiOutlinedInput-notchedOutline {
        border: 1px solid ${themeOptions.palette.gray.border};
      }
    }

    &:active {
      border-color: ${themeOptions.palette.green.main};
    }

    .MuiOutlinedInput-input {
      padding: 0px 0px 0px 12px;
      width: inherit;
      border-radius: 6px;
      outline: none;
      appearance: none;
      cursor: pointer;

      &:disabled {
        background-color: ${themeOptions.palette.gray.light};
      }
    }
  }

  .MuiAutocomplete-input {
    padding-left: 13px !important;
  }

  .Mui-disabled.MuiAutocomplete-inputRoot {
    background-color: ${themeOptions.palette.gray.light};
  }

  .required {
    p {
      left: 16px;
    }

    & + .MuiOutlinedInput-input {
      padding: 0px 0px 0px 24px;
    }
  }
`;
